export const SCHEDULE_CLIENT_ID_HEADER = 'X-Client-Id'

const generateClientId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`
}

export const SCHEDULE_CLIENT_ID: string = generateClientId()

export const isOwnScheduleOrigin = (originClientId?: string | null): boolean | undefined => {
  if (!originClientId) return undefined
  return originClientId === SCHEDULE_CLIENT_ID
}
